module.exports = __webpack_public_path__ + "static/media/danger.d5581042.svg";